<template>
  <router-view />
  <Teleport to="body">
    <ACTIONMODAL />
    <OVERLAY />
    <SUCCESSALERTBOX>{{ interactive_store.backend_message }}</SUCCESSALERTBOX>
    <ERRORALERTBOX>{{ interactive_store.backend_message }}</ERRORALERTBOX>
  </Teleport>
</template>

<script setup>

import { onMounted, onUnmounted, ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router' 
import { useAdminStore } from './stores/admin';
import { useArmsStore } from './stores/arms';
import { useSettingStore } from './stores/settings';
import { useInteractiveStore } from './stores/interactive'
import API from "./api/index";

const router = useRouter()

const route = useRoute()

const admin_store = useAdminStore(); // Access the admin

const arms_store = useArmsStore()

const settings_store = useSettingStore();

const interactive_store = useInteractiveStore();

const windowWidth = ref(window.innerWidth)


// ── Auth guard ───────────────────────────────
watch(() => admin_store.isAuthenticated, (val) => {
  if (!val) {
    interactive_store.backend_message = 'Session expired'
    interactive_store.display_error_alert_box()
    setTimeout(() => router.push({ path: '/login' }), 1000)
  }
})


// Method to handle responsive sidebar logic
const responsiveSideBar = (width) => {
  if (width >= 992) { // for desktops
    interactive_store.side_bar_css = { "display": "block" }
    interactive_store.sub_container_css = { "width": "calc(100% - 250px)" }
    interactive_store.container_css = {
      "width": "100%",
      "height": "auto",
      "overflow-x": "auto",
      "overflow-y": "hidden"
    }
    interactive_store.open_hamburger_css = { "display": "none" }
    interactive_store.close_hamburger_css = { "display": "none" }
  } else {
    interactive_store.Close_Sidebar()
  }
}

// Watch for changes in window width
watch(windowWidth, (newWidth) => {

  responsiveSideBar(newWidth)

})

// Update the windowWidth ref on resize
const updateWindowWidth = () => {

  windowWidth.value = window.innerWidth

}

 
onMounted(() => {

window.addEventListener('resize', updateWindowWidth)

setInterval(async () => {   // In App.vue (your polling function)

  try {

    await admin_store.fetch_admin().catch(err => { // Try to fetch user but DON'T block the app if it fails

        console.log("Admin fetch failed (not logged in).", err); 
      
    });

    if (admin_store.isAuthenticated) {

        await Promise.all([

        arms_store.fetch_plans_history(),

        settings_store.fetch_settings()

        ]);
    }       
  
  } catch (error) {
    
    console.error("Polling error:", error);
  
  }

}, 300000); // 5 minutes

})



onUnmounted(() => {

  window.removeEventListener('resize', updateWindowWidth)

})

</script>

<style>
html, body {
  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  margin: 0;
  padding: 0;
  overflow: auto; 
  height: 100%;
}
</style>